export enum ErrorLogType {
    Unknown = 0,
    Payment = 1,
    MoveOuts = 2
}
